import { useSEO } from "../lib/seo";
import { Reveal } from "../components/Reveal";
import { SITE } from "../lib/config";

const CONTENT = {
  "aviso-legal": {
    title: "Aviso legal",
    metaTitle: "Aviso legal | Victoria Fuentes, Psicóloga en Málaga",
    metaDescription: "Aviso legal del sitio web de Victoria Fuentes, psicóloga sanitaria en Málaga, conforme a la LSSI-CE.",
    html: `
      <h2>1. Identidad del titular del sitio web</h2>
      <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:</p>
      <ul>
        <li><strong>Titular:</strong> Victoria Fuentes</li>
        <li><strong>NIF:</strong> 76435051W</li>
        <li><strong>Actividad:</strong> Psicóloga Sanitaria</li>
        <li><strong>Nº de colegiada:</strong> AO-12347</li>
        <li><strong>Colegio profesional:</strong> Colegio Oficial de Psicología de Andalucía Oriental (COP-AO)</li>
        <li><strong>Domicilio profesional:</strong> C/ Eslava 14, 2ª planta, oficina 7, 29002 Málaga (España)</li>
        <li><strong>Teléfono:</strong> 613 19 18 18</li>
        <li><strong>Email:</strong> victoriafuentespsicologa@gmail.com</li>
      </ul>
      <p>La actividad profesional está sujeta a las normas deontológicas del Consejo General de la Psicología de España y a la Ley 44/2003, de 21 de noviembre, de ordenación de las profesiones sanitarias.</p>

      <h2>2. Objeto</h2>
      <p>El presente sitio web tiene como finalidad ofrecer información sobre los servicios de psicología prestados por la titular, así como facilitar el contacto y la solicitud de cita. El acceso y uso del sitio atribuye la condición de usuario e implica la aceptación de las presentes condiciones.</p>

      <h2>3. Condiciones de uso</h2>
      <p>El usuario se compromete a hacer un uso adecuado de los contenidos del sitio y a no emplearlos para actividades ilícitas o contrarias a la buena fe. La información publicada en este sitio, incluidos los artículos del blog, tiene carácter divulgativo y no sustituye en ningún caso una valoración o tratamiento psicológico individualizado.</p>

      <h2>4. Propiedad intelectual e industrial</h2>
      <p>Todos los contenidos del sitio (textos, imágenes, diseño y código) son titularidad de Victoria Fuentes o de terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.</p>

      <h2>5. Responsabilidad</h2>
      <p>La titular no se hace responsable del mal uso que se realice de los contenidos del sitio, siendo responsabilidad exclusiva del usuario que accede a ellos. Se realizan los máximos esfuerzos para garantizar la disponibilidad y el correcto funcionamiento del sitio, sin que pueda garantizarse la ausencia total de interrupciones o errores.</p>

      <h2>6. Legislación aplicable</h2>
      <p>Las presentes condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a derecho.</p>
    `,
  },
  "politica-privacidad": {
    title: "Política de privacidad",
    metaTitle: "Política de privacidad | Victoria Fuentes, Psicóloga en Málaga",
    metaDescription: "Política de privacidad conforme al RGPD y la LOPDGDD del sitio de Victoria Fuentes, psicóloga sanitaria en Málaga.",
    html: `
      <p>La protección de tus datos personales es una prioridad. Esta política se ha elaborado conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD).</p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li><strong>Responsable:</strong> Victoria Fuentes</li>
        <li><strong>NIF:</strong> 76435051W</li>
        <li><strong>Nº de colegiada:</strong> AO-12347 (COP Andalucía Oriental)</li>
        <li><strong>Dirección:</strong> C/ Eslava 14, 2ª planta, oficina 7, 29002 Málaga</li>
        <li><strong>Email:</strong> victoriafuentespsicologa@gmail.com</li>
      </ul>

      <h2>2. Finalidad del tratamiento</h2>
      <p>Los datos que nos facilitas a través del formulario de contacto (nombre, email, teléfono y mensaje) se tratan con la finalidad de gestionar tu solicitud de cita o consulta y mantener el contacto contigo. No se utilizan para elaborar perfiles ni se ceden a terceros con fines comerciales.</p>

      <h2>3. Legitimación</h2>
      <p>La base legal para el tratamiento de tus datos es tu <strong>consentimiento</strong>, que otorgas al marcar la casilla correspondiente y enviar el formulario. Puedes retirar dicho consentimiento en cualquier momento.</p>

      <h2>4. Datos de salud y protección reforzada</h2>
      <p>Los datos relativos a la salud tienen la consideración de <strong>categorías especiales de datos</strong> conforme al artículo 9 del RGPD y gozan de una <strong>protección reforzada</strong>. Te pedimos que <strong>no incluyas información clínica o de salud en el formulario de contacto</strong>. Cualquier dato de salud necesario para la prestación del servicio psicológico se recogerá, en su caso, en el marco de la relación asistencial y con las garantías adicionales que exige la normativa.</p>

      <h2>5. Destinatarios</h2>
      <p>Tus datos no se comunican a terceros salvo obligación legal. Para el funcionamiento del sitio y el envío de comunicaciones podemos utilizar proveedores de servicios (alojamiento y envío de correo electrónico) que actúan como encargados del tratamiento con las debidas garantías.</p>

      <h2>6. Plazo de conservación</h2>
      <p>Los datos se conservarán durante el tiempo necesario para atender tu solicitud y, posteriormente, durante los plazos legalmente exigibles. Cuando dejen de ser necesarios, serán suprimidos de forma segura.</p>

      <h2>7. Tus derechos (ARSULIPO)</h2>
      <p>Puedes ejercer tus derechos de <strong>Acceso, Rectificación, Supresión, Limitación del tratamiento, Portabilidad y Oposición</strong>, así como retirar tu consentimiento, dirigiéndote por escrito a victoriafuentespsicologa@gmail.com, indicando el derecho que deseas ejercer y adjuntando copia de un documento identificativo. Asimismo, tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que el tratamiento no se ajusta a la normativa.</p>
    `,
  },
  "politica-cookies": {
    title: "Política de cookies",
    metaTitle: "Política de cookies | Victoria Fuentes, Psicóloga en Málaga",
    metaDescription: "Política de cookies del sitio de Victoria Fuentes, psicóloga en Málaga. Información sobre las cookies utilizadas y cómo gestionarlas.",
    html: `
      <h2>1. ¿Qué son las cookies?</h2>
      <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo para recordar información sobre tu visita. Este sitio utiliza cookies de forma responsable y respetando tu decisión: <strong>ninguna casilla aparece premarcada</strong> y puedes aceptar, rechazar o configurar su uso.</p>

      <h2>2. Cookies utilizadas</h2>
      <h3>Cookies técnicas o necesarias</h3>
      <ul>
        <li>Guardan tu preferencia respecto al aviso de cookies (aceptar/rechazar) para no volver a mostrártelo. Son imprescindibles para el funcionamiento del sitio y no requieren consentimiento.</li>
      </ul>
      <h3>Cookies de medición o análisis (opcionales)</h3>
      <ul>
        <li>Si las activas, nos ayudan a conocer de forma anónima cómo se utiliza el sitio para mejorarlo. Solo se instalan si prestas tu consentimiento.</li>
      </ul>

      <h2>3. Gestión y revocación del consentimiento</h2>
      <p>Puedes aceptar o rechazar las cookies no necesarias desde el banner que se muestra al acceder al sitio. Para <strong>revocar tu consentimiento</strong> en cualquier momento, puedes borrar las cookies almacenadas desde la configuración de tu navegador, lo que hará que el banner vuelva a mostrarse para que decidas de nuevo.</p>
      <p>Además, la mayoría de navegadores permiten bloquear o eliminar las cookies desde sus opciones de configuración. Ten en cuenta que desactivar las cookies técnicas puede afectar al correcto funcionamiento del sitio.</p>

      <h2>4. Actualizaciones</h2>
      <p>Esta política puede actualizarse para adaptarse a cambios normativos o técnicos. Te recomendamos revisarla periódicamente.</p>
    `,
  },
};

export default function Legal({ page }) {
  const data = CONTENT[page];
  useSEO({
    title: data.metaTitle,
    description: data.metaDescription,
    path: `/${page}`,
  });

  return (
    <div data-testid={`legal-page-${page}`}>
      <section className="mx-auto max-w-3xl px-6 pb-8 pt-36 md:pt-44">
        <Reveal>
          <p className="overline">Información legal</p>
          <h1 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-6xl">{data.title}</h1>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl px-6 pb-24 md:pb-32">
        <Reveal>
          <article className="prose-therapy" dangerouslySetInnerHTML={{ __html: data.html }} />
          <p className="mt-12 text-sm text-ink-muted">Última actualización: {new Date().toLocaleDateString("es-ES", { month: "long", year: "numeric" })}. Titular: {SITE.name} · NIF {SITE.nif}.</p>
        </Reveal>
      </section>
    </div>
  );
}
